const resource = '/api/forms'

export default (ctx, $axios) => ({
  byId (id) {
    return $axios.get(`${resource}/get/UmbracoFormsProvider_${id}`)
  },
  submit (id, pageId, formData) {
    return $axios.post(`${resource}/addentry/UmbracoFormsProvider_${id}/${pageId}`, formData)
  }
})